import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { DropdownsOpenFactory } from '@shared/factories/dropdowns-open/dropdowns-open.factory';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { ByWordPipe } from '@shared/filters/by-word/by-word.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { Tooltip, TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'button-with-text-menu',
    templateUrl: './button-with-text-menu.component.html',
    standalone: true,
    imports: [
      AfTranslatePipe,
      SpanTooltipComponent,
      AfTranslateDirective,
      OverlayPanelModule,
      FormsModule,
      NgClass,
      ByWordPipe,
      AfOrderByPipe,
      TooltipModule
    ]
})
export class ButtonWithTextMenuComponent implements AfterViewInit {
  constructor(private dropdownsOpenFactory: DropdownsOpenFactory,
    private commonUtilsService: CommonUtilsService
  ) { }
  buttonWithTextMenu: any = {
    inputFilter: ''
  }
  @Input() item : any = {};
  @Input() multiline : number = 2;
  @Input() textButton : string = '';
  @Input() icon : string = '';
  @Input() disabled : boolean = false;
  @Input() buttonClass : string = 'common-button__text-border';
  @Output() launchActionEmitter = new EventEmitter();
  @ViewChild('overlayPanelTextMenu') overlayPanelTextMenu: OverlayPanel;
  @ViewChild(Tooltip) tooltip: Tooltip;

  ngAfterViewInit(): void {
    this.commonUtilsService.bindScrollOverlayListener(this.overlayPanelTextMenu);
  }

  resetFilter(){
    this.buttonWithTextMenu.inputFilter = '';
  }

  launchAction(action:any, optionAction:any){
    this.launchActionEmitter.emit({action: action, option: optionAction});
    this.dropdownsOpenFactory.closeDropdown();
    // if(action === 'copyLink'){
    //   this.showButtonTooltip();
    // }
  }

  showButtonTooltip(){
    this.buttonWithTextMenu.showTooltip = true;
    setTimeout(()=>{
      this.tooltip.show();
    }, 100)
    setTimeout(()=>{
      this.tooltip.hide();
      this.buttonWithTextMenu.showTooltip = false;
    }, 3000)
  }

  toggleFilter(e: any){
    this.commonUtilsService.toggleFilterOverlay(e, this.overlayPanelTextMenu, 'overlay');
  }
}
